import { render } from "./_Main.vue?vue&type=template&id=f04ae5ca&lang=en"
import script from "./_Main.vue?vue&type=script&lang=js"
export * from "./_Main.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__